import { render, staticRenderFns } from "./AiCallingTokenText.vue?vue&type=template&id=6476824a&scoped=true&"
import script from "./AiCallingTokenText.vue?vue&type=script&lang=js&"
export * from "./AiCallingTokenText.vue?vue&type=script&lang=js&"
import style0 from "./AiCallingTokenText.vue?vue&type=style&index=0&id=6476824a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6476824a",
  null
  
)

export default component.exports